module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_glass_20_555555_1x400.png";